// extracted by mini-css-extract-plugin
module.exports = {"lootboyContainer":"LootboyContainer_lootboyContainer__37RL_","lootboyContent":"LootboyContainer_lootboyContent__2-US4","lootboyScroll":"LootboyContainer_lootboyScroll__2_RGt"};